// Type
export const EXTRA_SERVICE_TYPE = {
    EXPAND_IMAGE_THRESHOLD: 1,
    EXPAND_STORAGE_THRESHOLD: 2,
    OPEN_PORT: 3,
    NVLINK: 4,
    PARSEC: 5,
    HARDWARE_CHANGE: 6,
    LICENSE: 7,
    REPORT_ISSUES: 8,
};

// Status
export const EXTRA_SERVICE_HISTORY_FILTER_BY = {
    ALL: 0,
    PENDING: 1,
    IN_PROGRESS: 2,
    APPROVED: 3,
    REJECTED: 4,
}

// Tab name
export const EXTRA_SERVICE_TAB = {
    SELECTION_EXTRA_SERVICE: "SELECTION_EXTRA_SERVICE",
    EXTRA_SERVICE_HISTORY: "EXTRA_SERVICE_HISTORY",
}

// Status text
export const EXTRA_SERVICE_STATUS_TEXT = {
    "1": "Pending",
    "2": "In progress",
    "3": "Approved",
    "4": "Rejected",
}

// Style status text
export const EXTRA_SERVICE_STYLE_STATUS_TEXT = {
    "1": "status-text-pending",
    "2": "status-text-in-progress",
    "3": "status-text-approved",
    "4": "status-text-rejected",
}

// Style status text
export const EXTRA_SERVICE_STATUS_ICON = {
    "1": "el-icon-time",
    "2": "el-icon-loading",
    "3": "el-icon-check",
    "4": "el-icon-close",
}

// Description request
export const DESCRIPTION_REQUEST = {
    "1": "Request opening threshold to limit the number of images",
    "2": "Request to open threshold limit to drive Z",
    "3": "Requires opening the port on the machine",
    "4": "Requires NVLink",
    "5": "Support install Parsec to image",
    "6": "Request change hardware package",
    "7": "Request license",
    "8": "Report issues",
}

// Pre-fix request
export const PRE_FIX_REQUEST = {
    "1": "Threshold",
    "2": "Threshold",
    "3": "Port",
}

// Unit request
export const UNIT_REQUEST = {
    "1": "image",
    "2": "GB",
    "3": null,
}

// Unit request
export const REPORT_ISSUES_TYPE_DESCRIPTION = {
    "1": 'Unable to connect',
    "2": 'Black screen',
    "3": "Can't connect Z drive",
    "4": 'No data found on Z drive',
    "5": 'Other',
}

// Extra service request status
export const EXTRA_SERVICE_REQUEST_STATUS = {
    SUCCESS: 0,
    CURRENT_LESS_THAN_REQUEST_VALUE: 1,
    REQUEST_ALREADY_EXISTS: 2,
    NO_DEPOSIT: 3,
    NOT_PRIME: 4,
}